import { apiConfig } from "./apiConfig";
export function getFranchiseWeblocationID(addressParam:any,successHandler:any){
    var conceptID = window.objOSGlobal.requestBodyValues.ConceptId;
    var apiUrl = apiConfig.FranchiseLookUpService + window.DEFINE_VALUE.JS_API_KEY+'&Address=sAddressParamValue&IsRoundRobin=true&conceptID='+conceptID;
     apiUrl = apiUrl.replace("sAddressParamValue", encodeURIComponent(addressParam));
    $.ajax({
        type: "GET",
        url:apiUrl,
        contentType: "application/json",
        dataType: 'json',
        success: successHandler,
        error: function(error){
        //  console.log(error);
        }
    });
}